import { categoryAllowed, clearTrackingCookies } from "./cookie-consent";

const GA_ID = "G-GE3LHM487Q";
declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
    __GA_ID?: string;
    "ga-disable-G-GE3LHM487Q"?: boolean;
  }
}
let initialised = false;

export function applyAnalyticsConsent(): void {
  const allowed = categoryAllowed("analytics");
  window["ga-disable-G-GE3LHM487Q"] = !allowed;
  if (!allowed) {
    window.gtag?.("consent", "update", { analytics_storage: "denied", ad_storage: "denied", ad_user_data: "denied", ad_personalization: "denied" });
    clearTrackingCookies("analytics");
    return;
  }
  if (initialised) {
    window.gtag?.("consent", "update", { analytics_storage: "granted" });
    return;
  }
  initialised = true;
  window.__GA_ID = GA_ID;
  window.dataLayer = window.dataLayer ?? [];
  window.gtag = function () { window.dataLayer?.push(arguments); };
  window.gtag("consent", "default", { analytics_storage: "granted", ad_storage: "denied", ad_user_data: "denied", ad_personalization: "denied" });
  window.gtag("set", "developer_id.dZjgwMW", true);
  window.gtag("js", new Date());
  window.gtag("config", GA_ID, { anonymize_ip: true, send_page_view: true, allow_google_signals: false, allow_ad_personalization_signals: false });
  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);
}

export function trackAnalyticsPageView(): void {
  if (!categoryAllowed("analytics")) return;
  window.gtag?.("event", "page_view", { page_path: location.pathname, page_location: location.href, page_title: document.title, send_to: GA_ID });
}